<ion-content class="update-data-content" [scrollY]="false">
  <div class="form-container update-data-layout">

    <div class="update-data-banners ad-container" *ngIf="bannerData?.banners?.length">
      <swiper-container [slidesPerView]="1" autoplay="true" [pagination]="true" [navigation]="true" [loop]="true">
        <swiper-slide *ngFor="let ad of bannerData.banners">
          <ng-container *ngIf="ad.redirect_url">
            <a [href]="ad.redirect_url" target="_blank">
              <img class="banner-slide" [src]="ad.image" alt="Banner Image" style="width: 100%; display: block;" />
            </a>
          </ng-container>
          <ng-container *ngIf="!ad.redirect_url">
            <img class="banner-slide" [src]="ad.image" alt="Banner Image" style="width: 100%; display: block;" />
          </ng-container>
        </swiper-slide>
      </swiper-container>
    </div>

    <div class="update-data-header">
      <h4 class="ion-text-center ion-margin-bottom">Actualiza tus datos</h4>

      <h5 class="ion-text-center" *ngIf="!loadingFields">
        Por favor, completa la siguiente información para continuar:
      </h5>
    </div>

    <div class="form-scroll">
      <ion-grid>
        <ion-row *ngIf="loadingFields">
          <ion-col
            size="8"
            sizeMd="6"
            class="ion-text-center"
            style="margin: auto"
          >
            <ion-spinner name="crescent"></ion-spinner>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div class="ion-margin-top ion-padding-top" *ngIf="!loadingFields">
        <app-form [questions]="questions"></app-form>
      </div>
    </div>

    <div class="footer-actions">
      <ion-grid>
        <ion-row *ngIf="!loading">
          <ion-col size="8" sizeMd="6" style="margin: auto">
            <ion-button
              expand="block"
              class="ion-text-wrap"
              fill="clear"
              (click)="close()"
            >
              Volver
            </ion-button>
          </ion-col>
          <ion-col size="8" sizeMd="6" style="margin: auto">
            <ion-button expand="block" class="ion-text-wrap" (click)="submit()">
              Actualizar
            </ion-button>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="loading">
          <ion-col
            size="8"
            sizeMd="6"
            class="ion-text-center"
            style="margin: auto"
          >
            <ion-spinner name="crescent"></ion-spinner>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
</ion-content>

